import { useAdmin } from '@/hooks/useAdmin';
import { hasPermission, Permission } from '@/lib/permissions';

export function usePermission() {
  const { admin, loading } = useAdmin();

  const checkPermission = (required: Permission | Permission[]) => {
    // If admin exists (from cache or loaded), check permission
    // This allows optimistic rendering when admin is cached
    if (!admin || !admin.role) return false;
    return hasPermission(admin.role.permissions, required);
  };

  return {
    hasPermission: checkPermission,
    loading,
    isAdmin: !!admin,
    role: admin?.role,
  };
}

